module.exports = __webpack_public_path__ + "img/recruitment_illustration.dcd0565a.svg";